const constructUrlParams = function(params) {
    if (!params) {
        return ''
    }

    return `&${params}`
}

class FileService {

    constructor(api) {
        this.api = api
    }

    /**
     * Get binary url for supplied uuid and type.
     *
     * @param {string} uuid      Uuid for metadata object for binary.
     * @param {string} imType    Infomaker type, e.g. x-im/image.
     * @param {string} [binaryUri] URI to binary, e.g. im://image/znX8U1C123JLDjlksdfgb40_jIka.jpeg
     * @param {array} [fallbacks]  Optional list of fallbacks [service, preview, original]
     * @param {object} [params]    Object containing extra parameters for binary service
     * @returns {Promise.<T>|*}
     */
    getUrl(uuid, imType, binaryUri, fallbacks, params) {

        const endpointParams = constructUrlParams(params)

        let endpoint = '/api/binary/url/' + uuid + '?imType=' + imType + endpointParams

        if (binaryUri) {
            endpoint += '&binaryUri=' + encodeURIComponent(binaryUri)
        }

        if (Array.isArray(fallbacks)) {
            endpoint += '&fallbacks=' + encodeURIComponent(fallbacks.join(','))
        }

        return this.api.router.get(endpoint)
            .then(response => this.api.router.checkForOKStatus(response))
            .then(response => response.text())
            .then(url => {
                if (!url) {
                    return Promise.reject('Binary url could not be retrieved from backend')
                }
                else {
                    return url
                }
            })
            .catch(e => Promise.reject(e))
    }

    /**
     *
     * @param file
     * @param params
     * @returns {Promise}
     */
    uploadFile(file, params) {
        return this.api.upload.uploadFile(file, params)
    }

    uploadURL(url, imType) {
        const queryParams = {
            imType: imType
        }
        return this.api.upload.uploadUri(url, queryParams)
    }
}

export {FileService}
